const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/accounting-sandbox/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
interface AccountingSandboxBeforeLoadArgs {
  context: {
    flags: Partial<FlagKeys>;
    permissions: Partial<PermissionsResponseDTO>;
  };
  params: {
    org: string;
  };
}
export const accountingSandboxBeforeLoad = async ({
  context: {
    flags,
    permissions
  },
  params: {
    org
  }
}: AccountingSandboxBeforeLoadArgs) => {
  if (!flags.mergeDevAccountingEnabled || !permissions.edit_integrations) {
    throw redirect({
      to: '/org/$org',
      params: {
        org
      },
      replace: true
    });
  }
};
export const Route = createFileRoute('/(app)/org/$org/settings/accounting-sandbox/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: accountingSandboxBeforeLoad
});